function isEnText(text) {
  return text.toLowerCase() !== text.toUpperCase();
}
function isDummyText(text) {
  return text === "__DUMMY__";
}
function getEmptyDisplayText(_text, email) {
  const isDummy = isDummyText(_text);
  const text = isDummy ? email || "" : _text;
  const isEn = isEnText(text);
  if (isEn) {
    const words = text.split(" ");
    const firstLetter = words[0].charAt(0).toUpperCase();
    const lastLetter = words[words.length - 1].charAt(0).toUpperCase();
    if (words.length === 1) {
      return firstLetter;
    }
    return `${firstLetter}${lastLetter}`;
  }
  const withoutWhiteSpaceText = text.replace(/\s/g, "");
  return withoutWhiteSpaceText.slice(withoutWhiteSpaceText.length - 2);
}

export { getEmptyDisplayText as default };
//# sourceMappingURL=getEmptyDisplayText.mjs.map
